// frontend_react/src/utils/tax_utils.js

/**
 * Calcule le prix TTC à partir d’un prix HT et d’un taux de TVA.
 * @param {number|string} unit_ht 
 * @param {number|string} vat_rate en pourcentage, ex : 20 pour 20%
 * @returns {number} arrondi à 2 décimales
 */
export function calculate_unit_ttc_from_ht(unit_ht, vat_rate) {
  const ht   = parseFloat(unit_ht);
  const rate = parseFloat(vat_rate) / 100;
  return Math.round((ht * (1 + rate)) * 100) / 100;
}

/**
 * Calcule le prix HT à partir d’un prix TTC et d’un taux de TVA.
 * @param {number|string} unit_ttc 
 * @param {number|string} vat_rate en pourcentage, ex : 20 pour 20%
 * @returns {number} arrondi à 2 décimales
 */
export function calculate_unit_ht_from_ttc(unit_ttc, vat_rate) {
  const ttc  = parseFloat(unit_ttc);
  const rate = parseFloat(vat_rate) / 100;
  return Math.round((ttc / (1 + rate)) * 100) / 100;
}
